import { ReactNode } from 'react';

import { Box } from 'components/Box';
import { AnchorButton } from 'components/Button/AnchorButton';
import { Icon } from 'components/Icon';

type Props = {
  href: string;
  children: ReactNode | null | undefined;
};

export function CmsStickyHeaderLinksBlockExternalLink({
  href,
  children,
}: Props) {
  return (
    <AnchorButton href={href} target="_blank">
      {children}
      <Box transform="translateY(1px)" display="inline-block" ml="6px">
        <Icon name="arrow-up-right" size={12} />
      </Box>
    </AnchorButton>
  );
}
